// extracted by mini-css-extract-plugin
export default {"closeBtn":"CloseTicketButton_closeBtn__JZiXm","confirm":"CloseTicketButton_confirm__AVqGQ","question":"CloseTicketButton_question__8BtZp"};